import React from "react";
import findStep from "./findStep";
import useBotControlStore from "../../../storeModules/useBotControlStore";
import addMoneyMask from "../../../utils/addMoneyMask";
import InsuranceSelect from "../../../components/insuranceSelect";
import { shouldSelectCoupon } from "./proposalSteps";
import useInsuranceStore from "../../../storeModules/useInsuranceStore";
import InsuranceButton from "../../../components/insuranceSelect/InsuranceButton";
import { getInsuranceValue } from "../../../api/requests";
import {
  setLoadingMessage,
  removeLoadingMessage,
} from "../../../utils/setLoadingMessage";
import noConnectionHandler from "../../../utils/noConnectionHandler";
import trackConversacaoStep from "../../../utils/trackConversacaoStep";
import { persistInsuranceStore } from "../../../utils/resumeStorage";

export const buildInsuranceChoiceVariables = (isInsuranceHired) => ({
  opcao: isInsuranceHired ? "COM SEGURO" : "SEM SEGURO",
  seguro: Boolean(isInsuranceHired),
});

const handleInsuranceSelectConfirm = () => {
  const botMessages = useBotControlStore.getState().messages;
  const { isInsuranceHired } = useInsuranceStore.getState();
  const userText = isInsuranceHired
    ? "Ótima escolha!"
    : "Ok! Você escolheu seguir sem o seguro prestamista.";

  trackConversacaoStep({
    stepName: "escolha_seguro",
    userMessage: userText,
    userVariables: buildInsuranceChoiceVariables(isInsuranceHired),
    userOnly: true,
  });
  persistInsuranceStore();

  const userMessage = {
    sender: "user",
    text: userText,
  };

  useBotControlStore.setState({
    messages: [...botMessages, userMessage],
  });

  if (isInsuranceHired) {
    useBotControlStore.setState({
      currentStep: findStep("termos_seguro").index,
    });
  } else {
    shouldSelectCoupon();
  }
};

const insuranceSelectButtons = [
  <InsuranceButton text="CONFIRMAR" onClick={handleInsuranceSelectConfirm} />,
];

export const buildInsuranceSelectResumeMessage = (time, text) => ({
  sender: "bot",
  text,
  time,
  component: <InsuranceSelect />,
  loading: null,
  buttons: insuranceSelectButtons,
  name: "escolha_seguro",
  shouldPersistComponent: true,
});

const insuranceSteps = [
  {
    name: "valida_seguro",
    sender: "bot",
    text: () => {},
    action: async () => {
      await noConnectionHandler().then(async () => {
        setLoadingMessage();

        await getInsuranceValue()
          .then((response) => {
            const { idCotacao, valorPremio, dataCotacao } = response.data;

            const insuranceData = useInsuranceStore.getState();

            if (response.data) {
              useInsuranceStore.setState({
                ...insuranceData,
                idCotacao,
                valorPremio,
                dataCotacao,
              });
              persistInsuranceStore();
            }

            if (idCotacao && valorPremio) {
              useBotControlStore.setState({
                currentStep: findStep("apresentacao_seguro").index,
              });
            } else {
              shouldSelectCoupon();
            }
          })
          .catch(() => {
            shouldSelectCoupon();
          })
          .finally(() => {
            removeLoadingMessage("getInsuranceValue");
          });
      });
    },
  },
  {
    name: "apresentacao_seguro",
    sender: "bot",
    isWaitingForFetch: false,
    text: "Deseja proteger a sua cota contra imprevistos?",
    action: async () => {
      useBotControlStore.setState({
        currentStep: findStep("descricao_seguro").index,
      });
    },
  },
  {
    name: "descricao_seguro",
    sender: "bot",
    isWaitingForFetch: false,
    text: () => {
      const { valorPremio } = useInsuranceStore.getState();

      return `Por mais <b>${addMoneyMask(
        valorPremio,
      )}/mês</b> adicione o <b>Seguro Prestamista</b> e tenha coberturas em caso de morte, invalidez total por acidente e outras situações inesperadas.`;
    },
    action: async () => {
      useBotControlStore.setState({
        currentStep: findStep("escolha_seguro").index,
      });
    },
  },
  {
    name: "escolha_seguro",
    sender: "bot",
    text: () => {},
    historyMessage: "Selecione o seguro prestamista:",
    component: <InsuranceSelect />,
    buttons: insuranceSelectButtons,
  },
  {
    name: "termos_seguro",
    sender: "bot",
    text: () => {
      const termosPrestamistaLink =
        "https://chabot-cdn.mycon.com.br/seguro-prestamista/seguro-prestamista-termos.pdf";

      return `Aqui está o Termo de Adesão <br><br> <a class="link-highlight" href="${termosPrestamistaLink}" target="_blank" rel="noopener noreferrer">Termo de Adesão Seguro Prestamista</a>`;
    },
    action: async () => {
      shouldSelectCoupon();
    },
  },
];

export default insuranceSteps;
